import React from "react";

import { Formik } from "formik";

import { Button, BUTTON_SIZES } from "shared/components/Button";
import FlexContainer from "shared/components/FlexContainer";
import { UnderlineLink } from "shared/components/Links";
import Spacer from "shared/components/Spacer";
import { LargeTitle, RegularText } from "shared/components/Typography";
import { VeroModal } from "shared/components/vero-modal";

import { ApproveDealModalProps } from "../approve-deal-modal";

import { ApplicantsCheckList, Subtitle } from "../styled";

import { useResendToPmsModal } from "./context";
import { useHook } from "./hooks";

export const ResendToPmsModal = ({ deal }: ApproveDealModalProps) => {
  const state = useResendToPmsModal();
  const { resendToPms } = useHook(deal, state.hide);
  const { cancel$, submit$, submitting } = state;

  return (
    <Formik initialValues={{}} onSubmit={() => submit$.next(resendToPms())}>
      {({ submitForm }) => (
        <VeroModal {...state}>
          <LargeTitle>Resend to PMS</LargeTitle>
          <Subtitle>
            <RegularText strong>Applicants:&nbsp;</RegularText>
            <ApplicantsCheckList inline items={deal?.applicantsSummary} />
          </Subtitle>

          <Spacer size={Spacer.SIZES.default} />

          <FlexContainer
            justifyContent="flex-end"
            gap="24px"
            alignItems="center"
          >
            <UnderlineLink onClick={() => cancel$.next()}>Cancel</UnderlineLink>
            <Button
              type="primary"
              onClick={submitForm}
              size={BUTTON_SIZES.lg}
              loading={submitting}
            >
              Resend to PMS
            </Button>
          </FlexContainer>
        </VeroModal>
      )}
    </Formik>
  );
};
